import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DirectivesModule } from '../../directives/directives.module';
import { TierlistenelementComponent } from './tierlistenelement/tierlistenelement.component';

@NgModule({
    declarations: [TierlistenelementComponent],
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        DirectivesModule,
        MatTooltipModule,
    ],
    exports: [TierlistenelementComponent],
})
export class TierlistenelementModule {}
